import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { AuthService } from './auth.service';
import { AppOpenedRequest } from 'src/shared/api_types';
import { ApiService } from './api.service';
import { AppService } from './app.service';
//import * as Sentry from '@sentry/capacitor';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private platform: Platform,
    public auth: AuthService,
    public app: AppService,
    public api: ApiService,
  ) {
    console.debug('App - constructor')
    this.initializeApp();
  }

  async reportAppOpened(fromBackground: boolean) {
    // this can only be done when we are logged in (got a token)
    if (this.auth.hasToken()) {
      if (this.auth.isImpersonating()) {
        console.debug('App - is impersonating - not reporting app opened')
      }
      else {
        try {
          const versionInfo = await this.app.buildAppVersionInfo()
          const report: AppOpenedRequest = {
            ...versionInfo,
            fromBackground,
          }
          await this.api.postReportAppOpened(report)
        }
        catch (err: any) {
          console.warn('reportAppOpened error', err)
        }
      }
    }
    else {
      console.debug('App - no token - cant report app opened')
    }
  }

  initializeApp() {
    this.platform.ready().then(async() => {
      console.debug('app platform ready - platforms', this.platform.platforms())
      SplashScreen.hide()
    });
    // report app opened when the token has been loaded
    this.auth.isLoggedIn.subscribe((hasToken) => {
      if (hasToken) {
        console.debug('app auth has token')
        this.reportAppOpened(false)
      }
    })
    // report app opened when the app is resumed (hybrid app only)
    this.platform.resume.subscribe(() => {
      console.debug('app platform resumed')
      this.reportAppOpened(true)
    })
  }

  async ngOnInit() {
    console.debug('App - OnInit')
    // this.auth.email.subscribe({ next: (email) => {
    //   console.debug(`AppComponent setting sentry user to ${email}`)
    //   Sentry.setUser({ email })
    // }})
  }
}
